module.exports = __webpack_public_path__ + "img/nextsense.d297301.png";